import React, { Component, Fragment } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Dimmer, Loader, Segment } from 'semantic-ui-react'
import 'semantic-ui-css/components/dimmer.min.css'
import 'semantic-ui-css/components/loader.min.css'
import 'semantic-ui-css/components/segment.min.css'
import { fetchStaticPage } from '../../store/staticPage'
import Helmet from 'react-helmet'
import Ad from 'ion-ads'
import FORMATS from '../components/AdFormats'
import NotFound from './NotFound'
import Sidebar from '../components/Sidebar'

export class StaticPage extends Component {
  componentDidUpdate (prevProps) {
    // Re-fetch articles when the section changes
    if (prevProps.page !== this.props.page) {
      this.props.fetchStaticPage(this.props.page)
    }
  }

  componentWillMount () {
    this.props.fetchStaticPage(this.props.page)
  }

  render () {
    if (this.props.hasError) {
      return (
        <div className='content-wrapper'>
          <Helmet title='ERROR' />
          <p>Error: {this.props.error}</p>
        </div>
      )
    }
    if (this.props.hasFetched && this.props.staticPage) {
      let page = this.props.staticPage
      const showSidebar = this.props.page === 'magazine'
      if (page.body) {
        return (
          <Fragment>
            <div className='wrapper static-page'>
              <Helmet title={this.props.title} >
                <meta name='description' content={this.props.description} />
              </Helmet>
              <h1>{page.title}</h1>
              {showSidebar &&
                <div className='article-page'>
                  <div dangerouslySetInnerHTML={{ __html: page.body }} />
                  <Sidebar section={this.props.page} />
                </div>}
              {!showSidebar &&
                <div dangerouslySetInnerHTML={{ __html: page.body }} />
              }
            </div>
          </Fragment>
        )
      } else {
        return (
          <Fragment>
            <Ad isConnected={this.props.isConnected} path={`/${process.env.RAZZLE_DFP_CODE}/${this.props.page}`} slotId='leaderboard-top' targeting={{ leaderboard: 'top' }} collapseEmptyDiv className='advert-leaderboard-top' {...FORMATS.leaderboard} />
            <NotFound />
            <Ad isConnected={this.props.isConnected} path={`/${process.env.RAZZLE_DFP_CODE}/${this.props.page}`} slotId='leaderboard-bot' targeting={{ leaderboard: 'bot' }} collapseEmptyDiv className='advert-leaderboard-top' {...FORMATS.leaderboard} />
          </Fragment>
        )
      }
    } else {
      return (
        <Fragment>
          <Helmet title='Article' />
          <Segment>
            <Dimmer active>
              <Loader indeterminate size='large'>Loading Article</Loader>
            </Dimmer>
          </Segment>
        </Fragment>
      )
    }
  }
}
const mapStateToProps = (state) => (state.staticPage)
const mapDispatchToProps = (dispatch) => bindActionCreators({ fetchStaticPage }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(StaticPage)
